module.exports = __webpack_public_path__ + "img/20200503_143009.c6baa990.jpg";